import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import Error from "../pages/error";
import Login from "../pages/auth/pages/login";
import Register from "../pages/auth/pages/register/pages/register";
import Landing from "../pages/main";
import AppWrapper from "../components/AppWrapper";
import EmailVerification from "../pages/auth/pages/register/pages/email_verification";
import RegistrationWrapper from "../pages/auth/pages/register/components/RegistrationWrapper";
import ForgotPassword from "../pages/auth/pages/forgot_password/pages/forgot_password";
import ResetPassword from "../pages/auth/pages/forgot_password/pages/reset_password";
import LoggedInUserWrapper from "../pages/user/components/LoggedInUserWrapper";
import Dashboard from "../pages/user/pages/standard/pages/dashboard";
import Profile from "../pages/user/pages/standard/pages/profile";
import AdminUserWrapper from "../pages/user/components/AdminUserWrapper";
import AdminDashboard from "../pages/user/pages/admin/pages/deshboard";
import Users from "../pages/user/pages/admin/pages/users";
import ExpertAdvisor from "../pages/user/pages/standard/pages/expertadvisor";
import Licence from "../pages/user/pages/standard/pages/licence";
import ManageEAs from "../pages/user/pages/standard/pages/manage_eas";
import GenerateKey from "../pages/user/pages/standard/pages/generate_key";

import HelpPage from "../pages/article/pages/help";
import LegalPage from "../pages/article/pages/legal";
import DetailPage from "../pages/article/pages/details";
import Articles from "../pages/user/pages/admin/pages/articles";
import Logs from "../pages/user/pages/admin/pages/logs";
import EALink from "../pages/user/pages/standard/pages/ea_link";
import Partner from "../pages/user/pages/standard/pages/partner/pages/index";
import Shop from "../pages/user/pages/standard/pages/shop/pages/index";
import Orders from "../pages/user/pages/admin/pages/orders";
import Products from "../pages/user/pages/admin/pages/products";
import Earnings from "../pages/user/pages/standard/pages/partner/pages/earnings";
import AccountActivation from "../pages/auth/pages/account_activation";
import AppMembership from "../pages/auth/pages/app_membership";
import AITokens from "../pages/auth/pages/ai_tokens";
import WithdrawalsAdmin from "../pages/user/pages/admin/pages/withdrawals";
import AnnouncementsAdmin from "../pages/user/pages/admin/pages/announcements";
import PartnersAdmin from "../pages/user/pages/admin/pages/partners";
import BrokersAdmin from "../pages/user/pages/admin/pages/brokers";
import Welcome from "../pages/user/pages/welcome";
import MentorWelcome from "../pages/user/pages/welcome/mentor";
import StudentWelcome from "../pages/user/pages/welcome/student";


const mainRouter = createBrowserRouter(
    createRoutesFromElements(
        <Route >
            <Route element={<AppWrapper />} >
                <Route index element={<Landing />} />
                <Route element={<LoggedInUserWrapper authroutes={true} />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<RegistrationWrapper />} >
                        <Route index element={<Register />} />
                        <Route path="email-verification" element={<EmailVerification />} />
                    </Route>
                    <Route path="/register/:referrer" element={<RegistrationWrapper />}>
                        <Route index element={<Register />} />
                    </Route>
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    
                    <Route path="/account-activation" element={<AccountActivation />} />
                    <Route path="/account-activation/:id" element={<AccountActivation />} />
                </Route>

                <Route element={<LoggedInUserWrapper authroutes={false} />} >
                    <Route path="/home" element={<Dashboard />} />
                    <Route path="/home/:owner" element={<Dashboard />} />
                    <Route element={<AdminUserWrapper />}>
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/articles" element={<Articles />} />
                        <Route path="/announcements" element={<AnnouncementsAdmin />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/withdrawals" element={<WithdrawalsAdmin />} />
                        <Route path="/admin/partners" element={<PartnersAdmin />} />
                        <Route path="/brokers" element={<BrokersAdmin />} />
                        <Route path="/logs" element={<Logs />} />
                    </Route>
                    <Route path="/users/:id/profile" element={<Profile />} />
                    <Route path="/users/:id/eas" element={<ManageEAs />} />
                    <Route path="/eas/:id" element={<ExpertAdvisor />} />
                    <Route path="/eas/licence/:id" element={<Licence />} />
                    <Route path="/eas/:id/license/create" element={<GenerateKey />} />
                    <Route path="/eas/:id/link" element={<EALink />} />

                    <Route path="/partner" element={<Partner />} />
                    <Route path="/partner/:id" element={<Partner />} />
                    <Route path="/earnings" element={<Earnings />} />
                    <Route path="/earnings/:id" element={<Earnings />} />

                    <Route path="/shop" element={<Shop />} />
                    <Route path="/shop/:slug" element={<Shop />} />
                </Route>

                <Route path="/app-membership" element={<AppMembership />} />
                <Route path="/ai-tokens" element={<AITokens />} />
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/welcome/mentor" element={<MentorWelcome />} />
                <Route path="/welcome/student" element={<StudentWelcome />} />

                <Route path="/legal" element={<LegalPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/:slug" element={<DetailPage />} />
                

                <Route path="*" element={<div className="authincation h-100"><Error code={404} message="The page you were looking for is not found!" /></div>} />
            </Route>
        </Route>


    )
);

export default mainRouter;
